export default "__VITE_ASSET__sFgpH_$1__"